import * as React from 'react';

import {QUERY_STUDENT_COMPLETIONS} from '../studentQueries';
import {StudentTheme} from '../studentTheme';

import {TargetListScreen} from './TargetListScreen';

export const CompletionsScreen: React.FC<{theme: StudentTheme}> = ({theme}) => (
  <TargetListScreen
    theme={theme}
    query={QUERY_STUDENT_COMPLETIONS}
    campo="userCompletions"
    vazio="Você ainda não concluiu nada."
    erro="Não foi possível carregar os completados."
  />
);
